import { paths } from './paths';

export const cards = [
  {
    title: 'Age Calculator',
    text: 'Calculate your age in in years, months, weeks, and days',
    path: paths['age-calculator']
  },
  {
    title: 'Age Difference Calculator',
    text: 'Calculate the age difference between two persons given their birthdays',
    path: paths['age-difference']
  },
  {
    title: 'Days Left Calculator',
    text: 'Calculate how many days there are left until a certain date',
    path: paths['days-left']
  },
  {
    title: 'Age on Other planets Calculator',
    text: 'Calculate how old you would have been on other planets of the solar system',
    path: paths['planets-age']
  },
  {
    title: 'Next Birthday Calculator',
    text: 'Calculate how many days left till your next birthday',
    path: paths['next-birthday']
  },
  {
    title: 'Days You Lived Calculator',
    text: 'Calculate how many days you have lived so far',
    path: paths['days-you-lived']
  },
  {
    title: 'Zodiac Sign Finder',
    text: 'Find your Zodiac Sign based on the date of birth',
    path: paths['zodiac-sign']
  },
  {
    title: 'Day of The Week Calculator',
    text: 'Find out the weekday of a certain date',
    path: paths['week-day']
  },
  {
    title: 'Days Difference Calculator',
    text: 'Calculate how many days there are between two given dates',
    path: paths['days-difference']
  }
];
